var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 25,
  viewBox: "0 0 14 25",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.5715 7.87156C11.426 7.45469 11.1712 7.03781 10.8437 6.69042C10.1886 5.96089 9.20595 5.50928 8.11414 5.50928H5.27543C3.45575 5.50928 2 6.89886 2 8.63583C2 10.0949 3.05542 11.3802 4.58395 11.6929L8.91481 12.5961C10.5889 12.9435 11.7899 14.3678 11.7899 16.0006C11.7899 17.946 10.1522 19.5093 8.11414 19.5093H5.67576C4.07444 19.5093 2.72787 18.5366 2.21836 17.1817",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.87598 5.50868V2",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.87598 22.9838V19.4751",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgDollar;